export default __webpack_public_path__ + "static/6865-d5db6d319c44c51f8b38bbbb7f30c608.jpg";